import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { ChatType } from 'src/shared/schemas/chats/chat-data'

export const chats = createQueryKeys('chats', {
  detail: (chatId: string, type: ChatType) => [chatId, type],
  messageSuggestions: (matchId?: number, count?: number) => [matchId, count],
  channels: (query?: string, types?: ChatType[]) => [query, types],
})
